module.exports = __webpack_public_path__ + "img/svg.da8970ee.png";